<template>
  <Table :rows="rows" :columns="columns" :columnID="'idLiquidacionDetalle'" container-class="m-0" :tableClass="'table-hover'">
    <template #rows="{ rows: bodyRows }">
      <LiquidacionDetalleRow v-for="item in bodyRows" :key="item.idLiquidacionDetalle" :row="item" :mode="mode" :modalItem="modalItem"></LiquidacionDetalleRow>
      <tr class="font-weight-bolder">
        <td class="text-right" colspan="5">TOTAL</td>
        <td class="text-center">{{ total | number(2) }}</td>
        <td></td>
      </tr>
    </template>
  </Table>
</template>

<script>
import LiquidacionDetalleRow from "./LiquidacionDetalleRow.vue";
import Table from "../../shared/components/Table.vue";
export default {
  components: { Table, LiquidacionDetalleRow },
  props: {
    rows: Array,
    mode: String,
    total: Number,
    modalItem: Object,
  },
  computed: {
    columns() {
      return [
        ...(this.modalItem.modulo == "EN"
          ? [
              {
                key: "codigoEndose",
                label: "Código",
                width: 60,
                head_class: "text-center",
              },
            ]
          : []),
        {
          key: "fecha",
          width: 60,
          head_class: "text-center",
        },
        {
          key: "servicio",
        },
        {
          key: "hotel",
        },
        {
          key: "servicioTipo",
          label: "Tipo",
          head_class: "text-center",
          width: 50,
        },
        {
          key: "moneda",
          head_class: "text-center",
          width: 60,
        },
        {
          key: "precio",
          label: "Monto",
          head_class: "text-center",
          width: 60,
        },
        {
          key: "observaciones",
        },
      ];
    },
  },
};
</script>
